import React from 'react';
import PropTypes from 'prop-types';
import TagManager from 'react-gtm-module';
import { withStyles } from '@material-ui/core/styles';
import {
  Typography,
  Modal,
  Button,
  TextField,
  CircularProgress
} from '@material-ui/core';

import Alerta from '../../../../../../util/snackbars/.mixins/';
import Auth from '../../../../../../../controllers/auth';

import EsqueciSenhaCss from './Esqueci_Senha-css';
import clsx from 'clsx';
const styles = EsqueciSenhaCss();

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

class EsqueciSenha extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      codigo: '',
      isLoading: false
    };
    this.inputRef = React.createRef();
    this.child = React.createRef();
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.setState = this.setState.bind(this);
  }

  handleOpen() {
    this.setState({ open: true });

    TagManager.dataLayer({
      dataLayer: {
        event: 'event',
        eventCategory: 'tokstok:fornecedores:login',
        eventAction: 'clique:botao',
        eventLabel: 'esqueceu-sua-senha',
      }
    });
  };

  handleClose() {
    setTimeout(() => {
      this.setState({ open: false });
      this.setState({ codigo: '' });
    }, 200);
  };

  async sendMail(props) {

    try {

      this.setState({ isLoading: true });

      var obj = {
        codigo: props.state.codigo,
      };

      if (obj.codigo === '') {
        return props.child.current.retorno('Preencha seu código!', 'warning');
      }

      var j_esqueciSenha = await Auth.esqueci_senha(obj);
      var o_esqueciSenha = JSON.parse(j_esqueciSenha.body);

      this.setState({ isLoading: false });
      if (o_esqueciSenha && o_esqueciSenha.status && o_esqueciSenha.status === true) {
        //fecha modal
        props.handleClose();
        //auxilia usuario
        //props.child.current.retorno('Verifique sua caixa de entrada do seu email!', 'success');
        props.child.current.retorno(o_esqueciSenha.message, 'success');

        TagManager.dataLayer({
          dataLayer: {
            event: 'event',
            eventCategory: 'tokstok:fornecedores:login',
            eventAction: 'callback',
            eventLabel: 'sucesso',
          }
        });
      } else {
        props.child.current.retorno('Não foi possível redefinir a senha!', 'error');
      }
    } catch (error) {
      props.child.current.retorno('Erro ao redefinir a senha!', 'error');

      TagManager.dataLayer({
        dataLayer: {
          event: 'event',
          eventCategory: 'tokstok:fornecedores:login',
          eventAction: 'callback',
          eventLabel: `erro:${error.message}`,
        }
      });
      console.error(error);
    }

  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
        >
          <div style={getModalStyle()} className={classes.paper}>
            {this.state.isLoading &&
              <div align="center">
                <Typography type="subheading" id="simple-modal-description">
                  Aguarde!
                </Typography>
                <br />
                <CircularProgress />
              </div>
            }
            {!this.state.isLoading &&
              <div>
                <Typography type="title" id="modal-title" className={classes.tituloModalRemove}>
                  <i className="material-icons">
                    vpn_key
                  </i>
                  Redefinir senha
                </Typography>
                <Typography type="subheading" id="simple-modal-description">
                  Coloque seu código para definir a senha!
                </Typography>
                <br />
                <TextField variant={"filled"}
                  id="tf_codigo"
                  name="tf_codigo"
                  label="Código"
                  InputProps={{
                    className: classes.multilineColor
                  }}
                  data-validate="Código válido é requerido: ex:6666666"
                  className={clsx(classes.textField, 'validate-input')}
                  value={this.state.codigo}
                  onChange={(e) => { this.setState({ codigo: e.target.value }) }}
                  margin="normal"
                />
                <br />
                <div align="right">
                  <Button className={classes.buttonCancelar} onClick={this.handleClose}>
                    Cancelar
                  </Button>
                  <Button variant="contained" className={classes.buttonRemover} onClick={(e) => { this.sendMail(this) }}>
                    Redefinir
                  </Button>
                </div>
                <EsqueciSenhaWrapped />
              </div>
            }
          </div>
        </Modal>
        <Alerta ref={this.child} />
      </div>
    );
  }
}

EsqueciSenha.propTypes = {
  classes: PropTypes.object.isRequired,
};


const EsqueciSenhaWrapped = withStyles(styles)(EsqueciSenha);

export default EsqueciSenhaWrapped;